import { render, staticRenderFns } from "./otpSenderWaysModal.vue?vue&type=template&id=d2a80f46&scoped=true"
import script from "./otpSenderWaysModal.vue?vue&type=script&lang=js"
export * from "./otpSenderWaysModal.vue?vue&type=script&lang=js"
import style0 from "./otpSenderWaysModal.vue?vue&type=style&index=0&id=d2a80f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a80f46",
  null
  
)

export default component.exports